// delReports/actions.js

import { Del } from "../../../models/Del/Del";
import { getDelInfo } from "../../../api/DelApi";
import { activeDelReportingInitialState } from "./activeDelsDelReportsState";
import { delFormInitialState } from "../../forms/delForm/delFormState";
// Importing the utility files for fetching del information
import { DelUtils } from "../utils/DelUtils";
// Importing the actions for the del form
import { makeDelFormActionsForTab } from "../../forms/delForm/delFormActions";

export const makeActiveDelReportingActions = (set, get) => ({
  fetchDel: async (delMode, delId) => {
    set((s) => ({
      activeDelReporting: {
        ...s.activeDelReporting,
        isLoading: true,
        error: null,
      },
    }));
    try {
      const info = await getDelInfo(delId, delMode);
      // console.log("info", info);
      if (info.del_info === false) {
        set((s) => ({
          activeDelReporting: {
            ...s.activeDelReporting,
            isLoading: false,
            error: "DEL not found or could not be loaded.",
          },
        }));
        return { ok: false, error: "DEL not found or could not be loaded." };
      }
      const newDel = new Del(info.del_info);
      // Transform the del data
      // To prevent errors we need to make sure that the projects and employeePositions lists are loaded and keep checking if they are not
      while (get().projects.loading || get().employeePositions.loading) {
        await new Promise((resolve) => setTimeout(resolve, 500));
      }

      const projects = get().projects.list;
      const employeePositions = get().employeePositions.list;
      const delUtils = new DelUtils(
        newDel,
        delMode,
        projects,
        employeePositions
      );
      const transformedDel = delUtils.transformDelData();
      // Group available project-specific units by table name for the UI
      const rawPsu = info.del_info.available_project_specific_units || [];
      const groupedPsu = {};
      if (Array.isArray(rawPsu) && rawPsu.length > 0) {
        groupedPsu["all"] = rawPsu;
        rawPsu.forEach((unit) => {
          const tbl = unit.unit_table_name || "other";
          if (!groupedPsu[tbl]) groupedPsu[tbl] = [];
          groupedPsu[tbl].push(unit);
        });
      }
      set((s) => ({
        activeDelReporting: {
          ...s.activeDelReporting,
          isLoading: false,
          currentDel: transformedDel,
          delMode,
          delActiveTab: "projects",
          delShowAll: false,
          delForm: {
            ...delFormInitialState,
            unitsUI: {
              ...delFormInitialState.unitsUI,
              availableProjectUnits: groupedPsu,
            },
            jsaFormUI: {
              ...delFormInitialState.jsaFormUI,
              base: {
                ...delFormInitialState.jsaFormUI.base,
                activeJsaTab: "All",
              },
            },
            wasteDisposalFormUI: {
              ...delFormInitialState.wasteDisposalFormUI,
              base: {
                ...delFormInitialState.wasteDisposalFormUI.base,
                activeWasteDisposalTab: "All",
              },
            },
          },
        },
      }));
      return { ok: true };
    } catch (err) {
      set((s) => ({
        activeDelReporting: {
          ...s.activeDelReporting,
          isLoading: false,
          error: err,
          currentDel: null,
          delMode: null,
        },
      }));
      return { ok: false, error: err };
    }
  },

  clearDel: () =>
    set((s) => ({
      activeDelReporting: {
        ...activeDelReportingInitialState,
        tabName: "reporting",
      },
    })),

  // UI helpers
  setActiveTab: (tabName) =>
    set((s) => ({
      activeDelReporting: { ...s.activeDelReporting, delActiveTab: tabName },
    })),
  setShowAll: (show) =>
    set((s) => ({
      activeDelReporting: { ...s.activeDelReporting, delShowAll: show },
    })),
  setDelErrors: (errors) =>
    set((s) => ({
      activeDelReporting: { ...s.activeDelReporting, delErrors: errors },
    })),

  delFormActions: Object.freeze(
    makeDelFormActionsForTab(set, get, "activeDelReporting")
  ),
});
